import { Link } from "react-router-dom";
import { platformStats, categories } from "@/mocks/articles";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function AboutPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AboutPage",
        "@id": "http://dlqlbdnn.cn/about",
        "url": "http://dlqlbdnn.cn/about",
        "name": "关于我们 - 洞察日报",
        "description": "了解洞察日报的使命、平台数据和商务合作信息。",
        "publisher": {
          "@type": "Organization",
          "name": "洞察日报"
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": "http://dlqlbdnn.cn/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "关于我们",
            "item": "http://dlqlbdnn.cn/about"
          }
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "洞察日报是什么类型的平台？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "洞察日报是一家专注于深度内容生产的新媒体平台，内容涵盖科技、商业、生活、文化和国际五大领域。"
            }
          },
          {
            "@type": "Question",
            "name": "如何与洞察日报进行商务合作？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "您可以通过商务邮箱 hello@dlqlbdnn.cn、联系电话 +86 400-888-9999，或前往北京市朝阳区建国路88号与我们取得联系。我们欢迎品牌内容合作、广告投放、活动联名和数据研究等多种形式的合作。"
            }
          },
          {
            "@type": "Question",
            "name": "如何订阅洞察日报的内容？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "您可以在网站底部输入您的邮箱地址订阅我们的每周简报，或者在关于我们页面找到订阅入口。"
            }
          }
        ]
      }
    ]
  };

  return (
    <div className="min-h-screen">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="relative h-[350px] md:h-[450px] w-full overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20editorial%20newsroom%20workspace%20with%20multiple%20monitors%2C%20warm%20ambient%20lighting%2C%20professional%20atmosphere%2C%20sleek%20desks%20with%20coffee%20cups%20and%20notebooks%2C%20large%20windows%20with%20city%20view%2C%20editorial%20photography%20style%2C%20warm%20neutral%20tones%2C%20high-end%20professional%20environment&width=1600&height=900&seq=about-hero&orientation=landscape"
            alt="About Us"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60" />
          <div className="absolute inset-0 flex items-center justify-center text-center px-4">
            <div>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
                关于洞察日报
              </h1>
              <p className="text-white/80 text-base md:text-lg max-w-2xl">
                用深度内容连接世界，让每一篇报道都有价值
              </p>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-8 py-12 md:py-20">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
              我们的使命
            </h2>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
              洞察日报成立于2020年，是一家专注于深度内容生产的新媒体平台。在信息过载的时代，我们相信优质内容的价值——不是追逐热点，而是提供洞察；不是制造焦虑，而是传递思考。
            </p>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
              我们的内容涵盖科技、商业、生活、文化和国际五大领域，汇聚了一批资深编辑和专栏作者，致力于为全球中文读者提供有深度、有温度、有观点的内容产品。
            </p>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
              从每日早报的长文精选，到每周的深度专题，从行业趋势的分析解读，到人文思考的娓娓道来，我们希望每一篇文章都能为读者带来新的视角和启发。
            </p>
          </div>
        </section>

        <section className="px-4 md:px-8 py-12 md:py-20 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
              平台数据
            </h2>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {platformStats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-50 rounded-2xl p-6 md:p-8 text-center border border-background-200/70"
                >
                  <p className="font-heading text-3xl md:text-4xl font-bold text-primary-500 mb-2">
                    {stat.value}
                  </p>
                  <p className="text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-8 py-12 md:py-20">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
              内容领域
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-2xl p-6 hover:border-primary-300 transition-colors"
                >
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {cat.name}
                    </h3>
                    <span className="w-8 h-8 flex items-center justify-center bg-background-100 rounded-full group-hover:bg-primary-100 transition-colors">
                      <i className="ri-arrow-right-line text-foreground-500 group-hover:text-primary-500 text-sm" />
                    </span>
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {cat.description}
                  </p>
                  <p className="text-xs text-foreground-400 mt-3">
                    {cat.articleCount} 篇文章
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-8 py-12 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6 text-center">
              商务合作
            </h2>
            <p className="text-foreground-600 text-base text-center mb-10 max-w-2xl mx-auto">
              我们欢迎各类商务合作，包括品牌内容合作、广告投放、活动联名、数据研究等。请通过以下方式联系我们。
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-50 rounded-2xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-mail-line text-primary-500" />
                  </span>
                </div>
                <h3 className="font-medium text-foreground-950 mb-1">商务邮箱</h3>
                <p className="text-sm text-foreground-500">hello@dlqlbdnn.cn</p>
              </div>

              <div className="bg-background-50 rounded-2xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 bg-accent-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-phone-line text-accent-500" />
                  </span>
                </div>
                <h3 className="font-medium text-foreground-950 mb-1">联系电话</h3>
                <p className="text-sm text-foreground-500">+86 400-888-9999</p>
              </div>

              <div className="bg-background-50 rounded-2xl p-6 text-center border border-background-200/70">
                <div className="w-12 h-12 bg-secondary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-map-pin-line text-secondary-500" />
                  </span>
                </div>
                <h3 className="font-medium text-foreground-950 mb-1">办公地址</h3>
                <p className="text-sm text-foreground-500">北京市朝阳区建国路88号</p>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-8 py-12 md:py-20">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              加入我们的读者社区
            </h2>
            <p className="text-foreground-600 text-base mb-8">
              订阅洞察日报，每周获取精选内容推送
            </p>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                alert("感谢订阅！");
              }}
              className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            >
              <input
                type="email"
                name="email"
                placeholder="输入您的邮箱"
                required
                className="flex-1 px-4 py-3 border border-background-200/70 rounded-full text-sm focus:outline-none focus:border-primary-400"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap"
              >
                立即订阅
              </button>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}